<div class="dialog-form flex flex-col w-full min-h-0 overflow-hidden">
    <!-- Header -->
    <div class="dialog-form__header flex flex-row justify-between items-center flex-none shrink-0">
        <div class="text-2xl leading-6 font-bold px-6 py-4 flex items-center gap-2 break-all" *ngIf="!config?.isProfileEdit">
            <app-record-id-badge [value]="data?.user_id"></app-record-id-badge>
            {{ (this.data?.user_id ? 'Editar' : 'Cadastrar') | autoTranslate }} {{ label | autoTranslate }}
        </div>
        <div class="text-2xl leading-6 font-bold px-6 py-4 flex items-center break-all" *ngIf="config?.isProfileEdit">{{ 'Editar perfil' | autoTranslate }}</div>
        <div class="p-4">
            <button (click)="clear()" mat-icon-button>
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Body (scrollable) -->
    <div class="dialog-form__body flex-1 min-h-0 overflow-y-auto px-4 pb-4">
        <ng-container>
            <div
                class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 w-full space-y-1 text-center sm:text-left"
                *ngIf="!loadingData; else loadingTemplate"
            >
                <div class="w-full">
                    <form class="w-full" [formGroup]="form">
                        <!-- Conteúdo sem tabs para pacientes -->
                        <div *ngIf="config.type === 'PATIENT'" class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                            <div class="sm:col-span-3" *ngIf="showPatientCompanySelect">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Empresa</mat-label>
                                    <mat-select [formControlName]="'company_id'">
                                        <mat-option *ngFor="let company of patientCompanies" [value]="company.company_id">
                                            {{ company.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-3">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Origem</mat-label>
                                    <input type="text" disabled [value]="originLabel | autoTranslate" matInput />
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-6">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Nome</mat-label>
                                    <!-- Fake input to prevent autocomplete -->
                                    <input type="text" style="display: none" autocomplete="name" />
                                    <input
                                        type="text"
                                        [formControlName]="'name'"
                                        class=""
                                        matInput
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                    />
                                    <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-2">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Tipo de Documento</mat-label>
                                    <mat-select [formControlName]="'type_doc'" class="" matInput>
                                        <mat-option [value]="'CPF'">CPF</mat-option>
                                        <mat-option [value]="'CNPJ'">CNPJ</mat-option>
                                        <!-- <mat-option [value]="'RG'">RG</mat-option>
                                                <mat-option [value]="'CNH'">CNH</mat-option>
                                                <mat-option [value]="'OUTRO'">OUTRO</mat-option> -->
                                    </mat-select>
                                    <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-2">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Número do Documento</mat-label>
                                    <ng-container *ngIf="canViewFullDocument || !form.controls['user_id'].value">
                                        <input
                                            type="text"
                                            *ngIf="form.controls.type_doc.value != 'CNPJ'"
                                            [formControlName]="'num_doc'"
                                            mask="000.000.000-00"
                                            [validation]="false"
                                            class=""
                                            matInput
                                        />
                                        <input
                                            type="text"
                                            *ngIf="form.controls.type_doc.value == 'CNPJ'"
                                            [formControlName]="'num_doc'"
                                            mask="00.000.000/0000-00"
                                            [validation]="false"
                                            class=""
                                            matInput
                                        />
                                    </ng-container>
                                    <input
                                        *ngIf="!canViewFullDocument && form.controls['user_id'].value"
                                        type="text"
                                        [value]="maskedDocDisplay"
                                        readonly
                                        class=""
                                        matInput
                                    />
                                    <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-2">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Email</mat-label>
                                    <input type="text" [formControlName]="'email'" class="" matInput />
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-3" *ngIf="config.type !== 'PATIENT' && hasSystemAccess()">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full user-form-password-field">
                                    <mat-label autoTranslate>Senha</mat-label>
                                    <input type="password" autocomplete="new-password" [formControlName]="'password'" class="" matInput />
                                    <button
                                        *ngIf="isAdmin && form.controls['user_id'].value && form.controls['email']?.value"
                                        mat-icon-button
                                        matSuffix
                                        type="button"
                                        (click)="resendResetPassword()"
                                        [disabled]="sendingResetPassword"
                                        [matTooltip]="'Reenviar redefinição de senha' | autoTranslate"
                                    >
                                        <mat-icon>mail</mat-icon>
                                    </button>
                                    <mat-hint *ngIf="form.controls['user_id'].value" autoTranslate> Deixe em branco para manter a senha atual </mat-hint>
                                    <mat-hint *ngIf="!form.controls['user_id'].value" autoTranslate> Opcional - preencha para permitir login </mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-6">
                                <div class="user-form-phone-row flex flex-col sm:flex-row sm:items-end gap-4 w-full">
                                    <div class="user-form-phone-row__phone">
                                        <app-phone-field
                                            [ddiControl]="$any(form.controls['number_phone_country_code'])"
                                            [phoneControl]="$any(form.controls['number_phone'])"
                                            [whatsappControl]="$any(form.controls['number_phone_is_whatsapp'])"
                                        ></app-phone-field>
                                    </div>

                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full sm:flex-1">
                                        <mat-label autoTranslate>Sexo</mat-label>
                                        <mat-select [formControlName]="'sex'" class="" matInput>
                                            <mat-option [value]="'Masculino'"><span autoTranslate>Masculino</span></mat-option>
                                            <mat-option [value]="'Feminino'"><span autoTranslate>Feminino</span></mat-option>
                                            <mat-option [value]="'Outro'"><span autoTranslate>Outro</span></mat-option>
                                        </mat-select>
                                        <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                    </mat-form-field>

                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full sm:flex-1">
                                        <mat-label autoTranslate>Nascimento</mat-label>
                                        <input [formControlName]="'birthday_date'" [matDatepicker]="picker2" matInput />
                                        <span *ngIf="form.controls['age'].value" matSuffix class="age-badge mr-1">
                                            {{ form.controls['age'].value }} <span autoTranslate>anos</span>
                                        </span>
                                        <mat-datepicker-toggle matSuffix [for]="picker2"> </mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                        <mat-error *ngIf="this.form.get('birthday_date')?.errors?.['required']" autoTranslate> Campo Obrigatório </mat-error>
                                        <mat-error *ngIf="this.form.get('birthday_date')?.errors?.['minAge']" autoTranslate> Idade minima é 18 Anos </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="sm:col-span-3" *ngIf="config.type == 'PATIENT'">
                                <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                    <mat-label autoTranslate>Plano</mat-label>
                                    <mat-select [formControlName]="'health_plan_id'" class="" matInput>
                                        <mat-option *ngFor="let plan of plans" [value]="plan.health_plan_id">{{ plan.name | autoTranslate }}</mat-option>
                                    </mat-select>
                                    <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-3" *ngIf="config.type == 'PATIENT'">
                                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                    <mat-label [matTooltip]="'Número do Plano de Saúde' | autoTranslate" autoTranslate>N. Plano</mat-label>
                                    <input matInput formControlName="plan_number" />
                                </mat-form-field>
                            </div>

                            <div class="sm:col-span-6">
                                <div class="user-form-address rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4">
                                    <div class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" autoTranslate>Endereço</div>
                                    <div class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                                        <div class="sm:col-span-3">
                                            <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                <mat-label autoTranslate>Endereço</mat-label>
                                                <input type="text" [formControlName]="'address'" class="" matInput />
                                                <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                <mat-label autoTranslate>CEP</mat-label>
                                                <input type="text" [formControlName]="'cep'" [mask]="'00000-000'" class="" matInput />
                                                <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                <mat-label autoTranslate>Cidade</mat-label>
                                                <input type="text" [formControlName]="'city'" class="" matInput />
                                                <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                <mat-label autoTranslate>Número</mat-label>
                                                <input type="text" [formControlName]="'number'" class="" matInput />
                                                <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                <mat-label autoTranslate>Complemento</mat-label>
                                                <input type="text" [formControlName]="'complement'" class="" matInput />
                                                <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="sm:col-span-6 flex items-center gap-3" *ngIf="!config?.isProfileEdit && isAdmin">
                                <mat-slide-toggle [color]="'primary'" [formControlName]="'status'"></mat-slide-toggle>
                                <span autoTranslate>O usuário está ativo?</span>
                            </div>
                        </div>
                        <!-- Tabs para outros tipos de usuário -->
                        <mat-tab-group *ngIf="config.type !== 'PATIENT'" [(selectedIndex)]="selectedTabIndex">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('general')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('general')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>Dados Gerais</span>
                                    </span>
                                </ng-template>
                                <div class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                                    <div class="sm:col-span-6">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Nome</mat-label>
                                            <!-- Fake input to prevent autocomplete -->
                                            <input type="text" style="display: none" autocomplete="name" />
                                            <input
                                                type="text"
                                                [formControlName]="'name'"
                                                class=""
                                                matInput
                                                autocomplete="off"
                                                autocorrect="off"
                                                autocapitalize="off"
                                                spellcheck="false"
                                            />
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Tipo de Documento</mat-label>
                                            <mat-select [formControlName]="'type_doc'" class="" matInput>
                                                <mat-option [value]="'CPF'">CPF</mat-option>
                                                <mat-option [value]="'CNPJ'">CNPJ</mat-option>
                                                <!-- <mat-option [value]="'RG'">RG</mat-option>
                                                <mat-option [value]="'CNH'">CNH</mat-option>
                                                <mat-option [value]="'OUTRO'">OUTRO</mat-option> -->
                                            </mat-select>
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Número do Documento</mat-label>
                                            <ng-container *ngIf="canViewFullDocument || !form.controls['user_id'].value">
                                                <input
                                                    type="text"
                                                    *ngIf="form.controls.type_doc.value != 'CNPJ'"
                                                    [formControlName]="'num_doc'"
                                                    mask="000.000.000-00"
                                                    [validation]="false"
                                                    class=""
                                                    matInput
                                                />
                                                <input
                                                    type="text"
                                                    *ngIf="form.controls.type_doc.value == 'CNPJ'"
                                                    [formControlName]="'num_doc'"
                                                    mask="00.000.000/0000-00"
                                                    [validation]="false"
                                                    class=""
                                                    matInput
                                                />
                                            </ng-container>
                                            <input
                                                *ngIf="!canViewFullDocument && form.controls['user_id'].value"
                                                type="text"
                                                [value]="maskedDocDisplay"
                                                readonly
                                                class=""
                                                matInput
                                            />
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>RG</mat-label>
                                            <input type="text" [formControlName]="'rg'" class="" matInput />
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Email</mat-label>
                                            <input type="text" [formControlName]="'email'" class="" matInput />
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Idioma padrão da interface</mat-label>
                                            <mat-select [formControlName]="'preferred_ui_language'">
                                                <mat-option [value]="null">
                                                    <span autoTranslate>Usar padrão do dispositivo</span>
                                                </mat-option>
                                                <mat-option *ngFor="let opt of availableUiLanguages" [value]="opt.code">{{ opt.name }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3" *ngIf="config.type !== 'PATIENT' && (!form.get('permission_group_id')?.value || hasSystemAccess())">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full user-form-password-field">
                                            <mat-label autoTranslate>Senha</mat-label>
                                            <input type="password" autocomplete="new-password" [formControlName]="'password'" class="" matInput />
                                            <button
                                                *ngIf="isAdmin && form.controls['user_id'].value && form.controls['email']?.value"
                                                mat-icon-button
                                                matSuffix
                                                type="button"
                                                (click)="resendResetPassword()"
                                                [disabled]="sendingResetPassword"
                                                [matTooltip]="'Reenviar redefinição de senha' | autoTranslate"
                                            >
                                                <mat-icon>mail</mat-icon>
                                            </button>
                                            <mat-hint *ngIf="form.controls['user_id'].value" autoTranslate> Deixe em branco para manter a senha atual </mat-hint>
                                            <mat-hint *ngIf="!form.controls['user_id'].value" autoTranslate> Opcional - preencha para permitir login </mat-hint>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-6">
                                        <app-phone-field
                                            [ddiControl]="$any(form.controls['number_phone_country_code'])"
                                            [phoneControl]="$any(form.controls['number_phone'])"
                                            [whatsappControl]="$any(form.controls['number_phone_is_whatsapp'])"
                                        ></app-phone-field>
                                    </div>

                                    <div class="sm:col-span-6">
                                        <div class="user-form-address rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4">
                                            <div class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" autoTranslate>Endereço</div>
                                            <div class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                                                <div class="sm:col-span-3">
                                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                        <mat-label autoTranslate>Endereço</mat-label>
                                                        <input type="text" [formControlName]="'address'" class="" matInput />
                                                        <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div class="sm:col-span-3">
                                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                        <mat-label autoTranslate>CEP</mat-label>
                                                        <input type="text" [formControlName]="'cep'" [mask]="'00000-000'" class="" matInput />
                                                        <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div class="sm:col-span-3">
                                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                        <mat-label autoTranslate>Cidade</mat-label>
                                                        <input type="text" [formControlName]="'city'" class="" matInput />
                                                        <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div class="sm:col-span-3">
                                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                        <mat-label autoTranslate>Número</mat-label>
                                                        <input type="text" [formControlName]="'number'" class="" matInput />
                                                        <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div class="sm:col-span-3">
                                                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                                        <mat-label autoTranslate>Complemento</mat-label>
                                                        <input type="text" [formControlName]="'complement'" class="" matInput />
                                                        <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Sexo</mat-label>
                                            <mat-select [formControlName]="'sex'" class="" matInput>
                                                <mat-option [value]="'Masculino'"><span autoTranslate>Masculino</span></mat-option>
                                                <mat-option [value]="'Feminino'"><span autoTranslate>Feminino</span></mat-option>
                                                <mat-option [value]="'Outro'"><span autoTranslate>Outro</span></mat-option>
                                            </mat-select>
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Data de Nascimento</mat-label>
                                            <input [formControlName]="'birthday_date'" [matDatepicker]="picker2" matInput />
                                            <mat-datepicker-toggle matSuffix [for]="picker2"> </mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                            <mat-error *ngIf="this.form.get('birthday_date')?.errors?.['required']" autoTranslate>
                                                Campo Obrigatório
                                            </mat-error>
                                            <mat-error *ngIf="this.form.get('birthday_date')?.errors?.['minAge']" autoTranslate>
                                                Idade minima é 18 Anos
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Idade Atual</mat-label>
                                            <input type="number" [formControlName]="'age'" class="" matInput />
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                            <mat-error *ngIf="this.form.get('birthday_date')?.errors?.['minAge']" autoTranslate>
                                                Idade minima é 18 Anos</mat-error
                                            >
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3" *ngIf="config.type == 'PATIENT'">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Plano</mat-label>
                                            <mat-select [formControlName]="'health_plan_id'" class="" matInput>
                                                <mat-option *ngFor="let plan of plans" [value]="plan.health_plan_id">{{ plan.name | autoTranslate }}</mat-option>
                                            </mat-select>
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-2" *ngIf="config.type == 'PATIENT'">
                                        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                            <mat-label [matTooltip]="'Número do Plano de Saúde' | autoTranslate" autoTranslate>N. Plano</mat-label>
                                            <input matInput formControlName="plan_number" />
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Origem</mat-label>
                                            <input type="text" disabled [value]="originLabel | autoTranslate" matInput />
                                        </mat-form-field>
                                    </div>

                                    <div
                                        class="sm:col-span-3"
                                        *ngIf="!config?.isProfileEdit && ['DOCTOR', 'NURSE', 'NURSING_TECH', 'DRIVER', 'PARAMEDIC', 'COMPANY_ADMIN', 'ADMIN'].includes(config.type)"
                                    >
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Grupo de Permissão</mat-label>
                                            <mat-select [formControlName]="'permission_group_id'" class="" matInput>
                                                <mat-option *ngFor="let group of permissionGroups" [value]="group.permission_group_id">
                                                    {{ group.name | autoTranslate }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error autoTranslate> Campo Obrigatório </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="sm:col-span-3" *ngIf="showRegimeSelect">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Regime de escala</mat-label>
                                            <mat-select [formControlName]="'regime_id'" class="" matInput>
                                                <mat-option [value]="null">{{ 'Nenhum' | autoTranslate }}</mat-option>
                                                <mat-option *ngFor="let regime of regimes" [value]="regime.regime_id">
                                                    {{ regime.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div
                                        class="sm:col-span-6 flex items-start gap-3 rounded-md border border-gray-200 dark:border-gray-700 p-3 bg-gray-50 dark:bg-gray-800/40"
                                        *ngIf="!config?.isProfileEdit"
                                    >
                                        <mat-slide-toggle [color]="'primary'" [formControlName]="'status'">
                                            <span class="font-medium" autoTranslate>O usuário está ativo?</span>
                                        </mat-slide-toggle>
                                    </div>

                                    <!-- Disponibilidade operacional: relevante somente para perfis que entram em escala/turno -->
                                    <div
                                        class="sm:col-span-6 flex items-start gap-3 rounded-md border border-gray-200 dark:border-gray-700 p-3 bg-gray-50 dark:bg-gray-800/40"
                                        *ngIf="['DOCTOR', 'NURSE', 'NURSING_TECH', 'DRIVER', 'PARAMEDIC'].includes(config.type)"
                                    >
                                        <mat-slide-toggle [color]="'primary'" [formControlName]="'is_available'">
                                            <span class="font-medium" autoTranslate>Disponível para alocação</span>
                                        </mat-slide-toggle>
                                        <span class="text-xs text-gray-500 dark:text-gray-400" autoTranslate>
                                            Quando indisponível, o usuário não aparece como opção ao montar um turno no cockpit.
                                        </span>
                                    </div>

                                    <!-- Regulador: elegível à escala remota; some da lista padrão de médicos -->
                                    <div
                                        class="sm:col-span-6 flex items-start gap-3 rounded-md border border-gray-200 dark:border-gray-700 p-3 bg-gray-50 dark:bg-gray-800/40"
                                        *ngIf="config.type === 'DOCTOR'"
                                    >
                                        <mat-slide-toggle [color]="'primary'" [formControlName]="'is_regulator'">
                                            <span class="font-medium" autoTranslate>É regulador</span>
                                        </mat-slide-toggle>
                                        <span class="text-xs text-gray-500 dark:text-gray-400" autoTranslate>
                                            Médico regulador fica elegível à escala remota e some da lista padrão de médicos.
                                        </span>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab *ngIf="config.type === 'DOCTOR' && data?.user_id">
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('crm')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('crm')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>CRMs</span>
                                        <span>({{ doctorCrms.length }})</span>
                                    </span>
                                </ng-template>
                                <div class="w-full mt-4">
                                    <div class="flex justify-end items-center mb-4">
                                        <button mat-icon-button color="primary" (click)="openCrmDialog()" [matTooltip]="'Adicionar CRM' | autoTranslate" [disabled]="loadingDoctor || !data?.user_id">
                                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="loadingCrms" class="flex justify-center py-8">
                                        <mat-spinner diameter="40"></mat-spinner>
                                    </div>
                                    <div *ngIf="!loadingCrms">
                                        <table class="w-full" mat-table [dataSource]="crmsDataSource">
                                            <!-- CRM Column -->
                                            <ng-container matColumnDef="crm">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>CRM</th>
                                                <td mat-cell *matCellDef="let item" (click)="openCrmDialog(item)" class="cursor-pointer">
                                                    {{ item.registration || item.crm_number + '-' + item.uf }}
                                                    <span *ngIf="item === getPrimaryCrm()" class="ml-2 text-xs text-primary">{{ '(Principal)' | autoTranslate }}</span>
                                                </td>
                                            </ng-container>

                                            <!-- UF Column -->
                                            <ng-container matColumnDef="uf">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>UF</th>
                                                <td mat-cell *matCellDef="let item" (click)="openCrmDialog(item)" class="cursor-pointer">{{ item.uf }}</td>
                                            </ng-container>

                                            <!-- Status Column -->
                                            <ng-container matColumnDef="status">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>Status</th>
                                                <td mat-cell *matCellDef="let item" (click)="openCrmDialog(item)" class="cursor-pointer">{{ (item.status || '-') | autoTranslate }}</td>
                                            </ng-container>

                                            <!-- Specialties Column -->
                                            <ng-container matColumnDef="specialties">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>Especialidades</th>
                                                <td mat-cell *matCellDef="let item" (click)="openCrmDialog(item)" class="cursor-pointer">
                                                    <span class="truncate block max-w-xs" [matTooltip]="(item.specialties || '-') | autoTranslate">{{ (item.specialties || '-') | autoTranslate }}</span>
                                                </td>
                                            </ng-container>

                                            <!-- Created At Column -->
                                            <ng-container matColumnDef="createdAt">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>Data de Cadastro</th>
                                                <td mat-cell *matCellDef="let item" (click)="openCrmDialog(item)" class="cursor-pointer">
                                                    {{ item.createdAt ? (item.createdAt | date : 'dd/MM/yyyy') : '-' }}
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="crmsColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: crmsColumns"></tr>

                                            <!-- Row shown when there is no data -->
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell p-4 text-center" [attr.colspan]="crmsColumns.length" autoTranslate>
                                                    Nenhum CRM cadastrado.
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab *ngIf="hasTechnicalDataTab">
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('technical')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('technical')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>Dados Técnicos</span>
                                    </span>
                                </ng-template>
                                <div class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                                    <!-- Professional Number - CRM/COREN/CNH (movido para o início) -->
                                    <div class="sm:col-span-3" *ngIf="config.type === 'DOCTOR' && !data?.user_id">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label>
                                                <span autoTranslate>N° CRM</span>
                                                <span *ngIf="!isCurrentCompanyBrazil()" autoTranslate> (opcional)</span>
                                            </mat-label>
                                            <input
                                                type="text"
                                                [formControlName]="'professional_number'"
                                                class=""
                                                matInput
                                                mask="00000-AA"
                                                [showMaskTyped]="true"
                                                [dropSpecialCharacters]="false"
                                                placeholder="12345-GO"
                                                (blur)="onCrmBlur()"
                                            />
                                            <button
                                                mat-icon-button
                                                matSuffix
                                                type="button"
                                                (click)="consultMedic()"
                                                [disabled]="form.get('professional_number')?.invalid"
                                                [matTooltip]="'Consultar CRM no CFM' | autoTranslate"
                                            >
                                                <mat-icon>search</mat-icon>
                                            </button>
                                            <mat-hint autoTranslate>Digite o número do CRM seguido de hífen e a UF (ex: 12345-GO)</mat-hint>
                                            <mat-error *ngIf="form.get('professional_number')?.hasError('required')" autoTranslate>Campo Obrigatório</mat-error>
                                            <mat-error *ngIf="form.get('professional_number')?.hasError('pattern')" autoTranslate>
                                                Formato inválido. Use: NÚMERO-UF (ex: 12345-GO)
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Professional Number - COREN/CNH (outros tipos) -->
                                    <div class="sm:col-span-3" *ngIf="config.type !== 'DOCTOR'">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label>
                                                <span *ngIf="isNurseLike" autoTranslate>N° COREN</span>
                                                <span *ngIf="config.type === 'DRIVER'" autoTranslate>N° CNH</span>
                                            </mat-label>
                                            <input 
                                                type="text" 
                                                [formControlName]="'professional_number'" 
                                                class="" 
                                                matInput 
                                            />
                                            <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="config.type !== 'DOCTOR'" class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Órgão Emissor</mat-label>
                                            <mat-select [formControlName]="'issuing_body'" class="" matInput>
                                                <mat-option *ngFor="let option of issuingBodyOptions" [value]="option.value">{{ option.label | autoTranslate }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Registration/License Issue Date -->
                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label>
                                                <span *ngIf="config.type === 'DOCTOR' || isNurseLike" autoTranslate>Data de Inscrição</span>
                                                <span *ngIf="config.type === 'DRIVER'" autoTranslate>Data de Validade</span>
                                            </mat-label>
                                            <input
                                                readonly
                                                [formControlName]="'license_issue_date'"
                                                [matDatepicker]="pickerIssue"
                                                (click)="pickerIssue.open()"
                                                matInput
                                            />
                                            <mat-datepicker-toggle matSuffix [for]="pickerIssue"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerIssue></mat-datepicker>
                                            <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Approved Status -->
                                    <div class="sm:col-span-3 flex items-center">
                                        <mat-slide-toggle [color]="'primary'" [formControlName]="'approved_status'">
                                            <span autoTranslate>Profissional aprovado?</span>
                                        </mat-slide-toggle>
                                    </div>

                                    <!-- First UF Registration / License Validity -->
                                    <div *ngIf="config.type == 'DRIVER' || isNurseLike" class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label>
                                                <span *ngIf="isNurseLike" autoTranslate>Primeira Inscrição na UF</span>
                                                <span *ngIf="config.type === 'DRIVER'" autoTranslate>Data 1ª Habilitação</span>
                                            </mat-label>
                                            <input
                                                readonly
                                                [formControlName]="'license_expiry_date'"
                                                [matDatepicker]="pickerExpiry"
                                                (click)="pickerExpiry.open()"
                                                matInput
                                            />
                                            <mat-datepicker-toggle matSuffix [for]="pickerExpiry"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerExpiry></mat-datepicker>
                                            <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- UF / Category -->
                                    <div class="sm:col-span-3" *ngIf="config.type !== 'DOCTOR' || !data?.user_id">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label>
                                                <span *ngIf="config.type === 'DOCTOR' || isNurseLike" autoTranslate>UF</span>
                                                <span *ngIf="config.type === 'DRIVER'" autoTranslate>Categoria</span>
                                            </mat-label>
                                            <input type="text" [formControlName]="'issuer_uf'" class="" matInput />
                                            <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Registration Number -->
                                    <div class="sm:col-span-3" *ngIf="isNurseLike">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Inscrição</mat-label>
                                            <input type="text" [formControlName]="'registration'" class="" matInput />
                                            <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Status -->
                                    <div class="sm:col-span-3" [ngClass]="{'sm:col-span-2': config.type === 'DOCTOR' && canCheckDoctorStatus}" *ngIf="config.type !== 'DOCTOR' || !data?.user_id">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Situação</mat-label>
                                            <mat-select [formControlName]="'license_status'" class="" matInput>
                                                <mat-option value="ATIVO">{{ 'Ativo' | autoTranslate }}</mat-option>
                                                <mat-option value="INATIVO">{{ 'Inativo' | autoTranslate }}</mat-option>
                                                <mat-option value="SUSPENSO">{{ 'Suspenso' | autoTranslate }}</mat-option>
                                                <mat-option value="CANCELADO">{{ 'Cancelado' | autoTranslate }}</mat-option>
                                            </mat-select>
                                            <mat-error autoTranslate>Campo Obrigatório</mat-error>
                                        </mat-form-field>
                                        <!-- Badge de status CFM (apenas para médicos) -->
                                        <div *ngIf="config.type === 'DOCTOR' && form.controls['license_status'].value" class="mt-1">
                                            <span
                                                [class]="getStatusBadgeClass(form.controls['license_status'].value)"
                                                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                                            >
                                                {{ getLicenseStatusLabel(form.controls['license_status'].value) | autoTranslate }}
                                            </span>
                                        </div>
                                    </div>

                                    <!-- Botão Verificar Status CFM (apenas para médicos) -->
                                    <div class="sm:col-span-1 flex items-end pb-4" *ngIf="(config.type === 'DOCTOR' && canCheckDoctorStatus) && (!data?.user_id)">
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            (click)="checkDoctorStatusCFM()"
                                            [disabled]="loading"
                                            class="w-full"
                                            [matTooltip]="'Verificar status do médico no CFM' | autoTranslate"
                                        >
                                            <mat-icon *ngIf="!loading">refresh</mat-icon>
                                            <mat-icon *ngIf="loading">hourglass_empty</mat-icon>
                                        </button>
                                    </div>

                                    <!-- License Emission Date (for drivers) -->
                                    <div class="sm:col-span-3" *ngIf="config.type === 'DRIVER'">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Data de Emissão</mat-label>
                                            <input
                                                readonly
                                                [formControlName]="'license_issue_date_emission'"
                                                [matDatepicker]="pickerEmission"
                                                (click)="pickerEmission.open()"
                                                matInput
                                            />
                                            <mat-datepicker-toggle matSuffix [for]="pickerEmission"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerEmission></mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                    <!-- Other States Registration -->
                                    <div class="sm:col-span-6" *ngIf="config.type === 'DOCTOR' || isNurseLike">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Inscrições em Outro Estado</mat-label>
                                            <textarea [formControlName]="'other_registration'" class="" matInput rows="3"></textarea>
                                        </mat-form-field>
                                    </div>

                                    <!-- Specialties / Courses -->
                                    <div class="sm:col-span-3" *ngIf="config.type === 'DOCTOR' && !data?.user_id">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Especialidades</mat-label>
                                            <input [formControlName]="'specialties_or_courses'" class="" matInput [readonly]="true" />
                                            <mat-hint autoTranslate>Preenchido automaticamente via API do CFM</mat-hint>
                                        </mat-form-field>
                                    </div>

                                    <!-- Practice Area -->
                                    <div class="sm:col-span-2" *ngIf="config.type === 'DOCTOR'">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Área de Atuação</mat-label>
                                            <input [formControlName]="'practice_area_or_courses'" class="" matInput/>
                                        </mat-form-field>
                                    </div>
                                    <!-- Graduation Institution -->
                                    <div class="sm:col-span-2" *ngIf="config.type === 'DOCTOR' || isNurseLike">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Instituição de Graduação</mat-label>
                                            <input type="text" [formControlName]="'graduation_institution'" class="" matInput />
                                        </mat-form-field>
                                    </div>

                                    <!-- Graduation Year -->
                                    <div class="sm:col-span-2" *ngIf="config.type === 'DOCTOR' || isNurseLike">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Ano de Formatura</mat-label>
                                            <input type="number" [formControlName]="'graduation_year'" class="" matInput />
                                        </mat-form-field>
                                    </div>

                                    <!-- Has Additional Courses -->
                                    <div class="sm:col-span-2" *ngIf="isNurseLike || config.type === 'DRIVER'">
                                        <mat-checkbox [color]="'primary'" [formControlName]="'has_additional_courses'">
                                            <span *ngIf="isNurseLike">{{ 'Possui cursos?' | autoTranslate }}</span>
                                            <span *ngIf="config.type === 'DRIVER'">{{ 'Possui curso CVE?' | autoTranslate }}</span>
                                        </mat-checkbox>
                                    </div>

                                    <!-- Course Details -->
                                    <div
                                        class="sm:col-span-4"
                                        *ngIf="(isNurseLike || config.type === 'DRIVER') && form.controls['has_additional_courses']?.value"
                                    >
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label>
                                                <span *ngIf="isNurseLike">{{ 'Quais cursos?' | autoTranslate }}</span>
                                                <span *ngIf="config.type === 'DRIVER'">{{ 'Detalhes do curso CVE' | autoTranslate }}</span>
                                            </mat-label>
                                            <textarea [formControlName]="'additional_courses_details'" class="" matInput rows="3"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab *ngIf="hasTechnicalDataTab">
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('attachments')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('attachments')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>Anexos</span>
                                    </span>
                                </ng-template>
                                <div class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                                    <!-- Photo -->
                                    <div class="sm:col-span-3 flex flex-col items-center">
                                        <img
                                            [src]="this.form.get('photo').value || 'assets/images/default.jpg'"
                                            [attr.alt]="'Foto do usuário' | autoTranslate"
                                            class="w-32 h-32 rounded-full object-cover cursor-pointer border-2 border-gray-300 hover:border-primary transition-colors"
                                            (click)="photoInput.click()"
                                        />
                                        <input #photoInput type="file" accept="image/*" style="display: none" (change)="onPhotoSelected($event)" />
                                        <mat-hint class="text-center mt-2" autoTranslate>Clique para enviar uma foto</mat-hint>
                                    </div>

                                    <!-- Document Card -->
                                    <div class="sm:col-span-3 flex flex-col">
                                        <div class="mb-4">
                                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                                <span *ngIf="config.type === 'DOCTOR'">{{ 'Carteira do CRM' | autoTranslate }}</span>
                                                <span *ngIf="isNurseLike">{{ 'Carteira do COREN' | autoTranslate }}</span>
                                                <span *ngIf="config.type === 'DRIVER'">{{ 'Carteira de motorista' | autoTranslate }}</span>
                                            </label>
                                            <input #fileInput type="file" (change)="onFileSelected($event)" class="hidden" />
                                            <button type="button" mat-raised-button color="primary" (click)="fileInput.click()" class="w-full" autoTranslate>
                                                📄 Enviar Documento
                                            </button>
                                            <div class="text-xs text-gray-500 mt-1">{{ 'Selecione documento para enviar' | autoTranslate }}</div>
                                        </div>
                                        <div *ngIf="this.form.get('document_card').value as document_card" class="mt-2">
                                            <a [href]="document_card" target="_blank" class="text-primary underline" autoTranslate>
                                                📄 Baixar documento enviado
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab *ngIf="config.type === 'DOCTOR'">
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('other')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('other')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>Outras Informações</span>
                                    </span>
                                </ng-template>
                                <div class="grid sm:grid-cols-6 gap-y-4 gap-x-6 w-full">
                                    <!-- Experiência prévia com APH -->
                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Experiência prévia com atendimento pré-hospitalar (APH)?</mat-label>
                                            <mat-select [formControlName]="'previous_aph_experience'" class="" matInput>
                                                <mat-option [value]="true">{{ 'Sim' | autoTranslate }}</mat-option>
                                                <mat-option [value]="false">{{ 'Não' | autoTranslate }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Já atuou com Telemedicina -->
                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Já atuou com Telemedicina?</mat-label>
                                            <mat-select [formControlName]="'telemedicine_experience'" class="" matInput>
                                                <mat-option [value]="true">{{ 'Sim' | autoTranslate }}</mat-option>
                                                <mat-option [value]="false">{{ 'Não' | autoTranslate }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Preferências de horários -->
                                    <div class="sm:col-span-6">
                                        <mat-label class="text-sm font-medium mb-2 block" autoTranslate>Preferências de horários para plantões</mat-label>
                                        <div class="flex flex-wrap gap-2">
                                            <mat-checkbox
                                                *ngFor="let option of shiftTimeOptions"
                                                [checked]="form.get('shift_time_preferences')?.value?.includes(option.value)"
                                                (change)="onShiftTimeChange($event, option.value)"
                                            >
                                                {{ option.label | autoTranslate }}
                                            </mat-checkbox>
                                        </div>
                                    </div>

                                    <!-- Preferências de dias da semana -->
                                    <div class="sm:col-span-6">
                                        <mat-label class="text-sm font-medium mb-2 block" autoTranslate>Preferências de dias da semana para plantões</mat-label>
                                        <div class="flex flex-wrap gap-2">
                                            <mat-checkbox
                                                *ngFor="let option of shiftDayOptions"
                                                [checked]="form.get('shift_day_preferences')?.value?.includes(option.value)"
                                                (change)="onShiftDayChange($event, option.value)"
                                            >
                                                {{ option.label | autoTranslate }}
                                            </mat-checkbox>
                                        </div>
                                    </div>

                                    <!-- Preferências de plantões -->
                                    <div class="sm:col-span-6">
                                        <mat-label class="text-sm font-medium mb-2 block" autoTranslate>Preferências de plantões</mat-label>
                                        <div class="flex flex-wrap gap-2">
                                            <mat-checkbox
                                                *ngFor="let option of shiftDurationOptions"
                                                [checked]="form.get('shift_duration_preferences')?.value?.includes(option.value)"
                                                (change)="onShiftDurationChange($event, option.value)"
                                            >
                                                {{ option.label | autoTranslate }}
                                            </mat-checkbox>
                                        </div>
                                    </div>

                                    <!-- Valor médio da hora atual -->
                                    <div class="sm:col-span-3">
                                        <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                                            <mat-label autoTranslate>Qual valor médio da sua hora atual?</mat-label>
                                            <input type="text" [formControlName]="'average_hourly_rate'" [options]="currencyMaskOptions" currencyMask class="" matInput />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab *ngIf="showCompaniesTab">
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('companies')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('companies')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>Empresas</span>
                                    </span>
                                </ng-template>
                                <div class="w-full mt-4">
                                    <div class="flex justify-between items-center mb-4">
                                        <h3 class="text-lg font-semibold" autoTranslate>Empresas Vinculadas</h3>
                                        <button mat-icon-button color="primary" (click)="addCompany()" [matTooltip]="'Adicionar Empresa' | autoTranslate">
                                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="loadingCompanies" class="flex justify-center py-8">
                                        <mat-spinner diameter="40"></mat-spinner>
                                    </div>
                                    <div *ngIf="!loadingCompanies">
                                        <table class="w-full" mat-table [dataSource]="companiesDataSource">
                                            <!-- Company Name Column -->
                                            <ng-container matColumnDef="company_name">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>Nome da Empresa</th>
                                                <td mat-cell *matCellDef="let item">{{ (item.company?.name || '-') | autoTranslate }}</td>
                                            </ng-container>

                                            <!-- Created At Column -->
                                            <ng-container matColumnDef="createdAt">
                                                <th mat-header-cell *matHeaderCellDef autoTranslate>Data de Vinculação</th>
                                                <td mat-cell *matCellDef="let item">
                                                    {{ item.createdAt ? (item.createdAt | date : 'dd/MM/yyyy') : '-' }}
                                                </td>
                                            </ng-container>

                                            <!-- Actions Column -->
                                            <ng-container matColumnDef="actions">
                                                <th mat-header-cell *matHeaderCellDef></th>
                                                <td mat-cell *matCellDef="let item" class="text-right">
                                                    <button
                                                        mat-icon-button
                                                        color="warn"
                                                        (click)="removeCompany(item)"
                                                        [matTooltip]="'Remover Vinculação' | autoTranslate"
                                                    >
                                                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                    </button>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="companiesColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: companiesColumns"></tr>

                                            <!-- Row shown when there is no data -->
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell p-4 text-center" [attr.colspan]="companiesColumns.length" autoTranslate>
                                                    Nenhuma empresa vinculada.
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </mat-tab>

                            <!-- Tab Notificações -->
                            <mat-tab *ngIf="showNotificationsTab">
                                <ng-template mat-tab-label>
                                    <span class="inline-flex items-center gap-1" [class.text-red-600]="tabSectionHasInvalid('notifications')">
                                        <mat-icon *ngIf="tabSectionHasInvalid('notifications')" class="!w-4 !h-4" color="warn">error</mat-icon>
                                        <span autoTranslate>Notificações</span>
                                    </span>
                                </ng-template>
                                <div class="w-full mt-4" [formGroup]="form">
                                    <div class="flex flex-col gap-1 mb-4">
                                        <h3 class="text-lg font-semibold" autoTranslate>Notificações WhatsApp</h3>
                                        <p class="text-sm text-gray-500 dark:text-gray-400">
                                            {{
                                                'Eventos disponíveis para o perfil deste usuário. Por padrão as notificações ficam desativadas na criação; ative apenas as que este usuário deve receber via WhatsApp.'
                                                    | autoTranslate
                                            }}
                                        </p>
                                    </div>

                                    <div *ngIf="loadingIntegrations" class="flex justify-center py-8">
                                        <mat-spinner diameter="40"></mat-spinner>
                                    </div>

                                    <ng-container *ngIf="!loadingIntegrations">
                                        <div *ngIf="eligibleAlertTypes.length === 0" class="text-sm text-gray-400 italic py-4">
                                            {{ 'Nenhum evento WhatsApp atribuído ao perfil deste usuário.' | autoTranslate }}
                                        </div>

                                        <div *ngIf="eligibleAlertTypes.length > 0" class="overflow-x-hidden rounded-lg border dark:border-gray-700" formGroupName="notificationPreferences">
                                            <table class="w-full text-sm border-collapse">
                                                <thead>
                                                    <tr class="bg-gray-100 dark:bg-gray-800 text-left text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                                                        <th class="px-3 py-2 font-semibold w-12 text-center" autoTranslate>Ativo</th>
                                                        <th class="px-3 py-2 font-semibold w-44" autoTranslate>Evento</th>
                                                        <th class="px-3 py-2 font-semibold" autoTranslate>Descrição</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let alert of eligibleAlertTypes; let odd = odd"
                                                        [class.bg-gray-50]="odd"
                                                        [class.dark:bg-gray-950]="odd"
                                                        class="border-t border-gray-200 dark:border-gray-700 align-middle"
                                                    >
                                                        <td class="px-3 py-2 text-center">
                                                            <mat-slide-toggle
                                                                [formControlName]="alert.type"
                                                                color="primary"
                                                            ></mat-slide-toggle>
                                                        </td>
                                                        <td class="px-3 py-2">
                                                            <span class="font-semibold text-gray-900 dark:text-white block leading-tight">{{ alert.alias | autoTranslate }}</span>
                                                            <span class="text-xs text-gray-400 font-mono">{{ alert.type }}</span>
                                                        </td>
                                                        <td class="px-3 py-2 text-xs text-gray-500 dark:text-gray-400">
                                                            {{ alert.description | autoTranslate }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </ng-container>
                                </div>
                            </mat-tab>

                        </mat-tab-group>
                    </form>
                </div>
            </div>

            <!-- loadingTemplate -->
            <ng-template #loadingTemplate>
                <div class="w-full h-full flex items-center justify-center">
                    <mat-spinner></mat-spinner>
                </div>
            </ng-template>
        </ng-container>
    </div>

    <!-- Footer -->
    <ng-container *ngIf="!loadingData">
        <div class="dialog-form__footer shrink-0 flex items-center justify-center sm:justify-between px-6 py-4 bg-gray-100 dark:bg-black dark:bg-opacity-10 gap-2 flex-wrap">
            <div>
                <ng-container *ngIf="data?.user_id && !config?.isProfileEdit">
                    <button *hasPermission="getDeletePermission()" (click)="deleteUser()" mat-stroked-button [color]="'warn'" autoTranslate>Remover</button>
                </ng-container>
            </div>
            <div></div>
            <div class="flex items-center gap-2 flex-wrap">
                <!-- Cancel -->
                <button (click)="clear()" mat-stroked-button [color]="'primary'" [matDialogClose]="'cancelled'" autoTranslate>Fechar</button>
                <!-- Confirm -->
                <ng-container>
                    <ng-container *ngIf="data?.user_id">
                        <button *hasPermission="getUpdatePermission()" (click)="done()" [disabled]="loading" [color]="'primary'" mat-flat-button>
                            <span autoTranslate>Atualizar</span>
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!data?.user_id">
                        <button *hasPermission="getCreatePermission()" (click)="done()" [disabled]="loading" [color]="'primary'" mat-flat-button>
                            <span autoTranslate>Salvar</span>
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>
